'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-tree-upload', {
      url: '/document-tree/upload',
      template: '<document-tree-upload></document-tree-upload>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/document/tree-upload/document-tree-upload.routes.js